import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
    PatientIdentity: {
        width: '100%',
    },
    PatientIdentitySection: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
    },
}))
